import PorteurService from '../services/porteur.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

export const porteurModule = {
  namespaced: true,

  actions: {
    async getDepensesCarte ({ commit }, cardList) {
      return PorteurService.getDepensesCarte(cardList).then(
        response => {
          const list = response.data
          return Promise.resolve(list)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getOperationsPorteur ({ commit }, rechercheOperationsPorteur) {
      return PorteurService.getOperationsPorteur(rechercheOperationsPorteur).then(
        response => {
          const list = response.data
          return Promise.resolve(list)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getRelevesOperationsPorteur ({ commit }, rechercheOperationsPorteur) {
      return PorteurService.getRelevesOperationsPorteur(rechercheOperationsPorteur).then(
        response => {
          const list = response.data
          return Promise.resolve(list)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getRelevesPorteur ({ commit }, rechercheRelevesPorteur) {
      return PorteurService.getRelevesPorteur(rechercheRelevesPorteur).then(
        response => {
          const list = response.data
          return Promise.resolve(list)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async downloadRelevesPorteurs ({ commit }, filesToDownload) {
      return PorteurService.downloadRelevesPorteurs(filesToDownload).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getOperationsCartePorteur ({ commit }, rechercheOperationsCartePorteur) {
      return PorteurService.getOperationsCartePorteur(rechercheOperationsCartePorteur).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getGestionnaire ({ commit }, entrepriseId) {
      return PorteurService.getGestionnaire(entrepriseId).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    selectEditedPeriod ({ commit }, periode) {
      commit('putPeriodeInStore', periode)
    },
    selectEditedEcheance ({ commit }, echeance) {
      commit('putEcheanceInStore', echeance)
    },
    selectListOperationsCarte ({ commit }, listOperationsCarte) {
      commit('putListOperationsCarteInStore', listOperationsCarte)
    }
  },
  mutations: {
    putPeriodeInStore (state, periode) {
      state.editedPeriode = periode
    },
    putListOperationsCarteInStore (state, listOperationsCarte) {
      state.listOperationsCarte = listOperationsCarte
    },
    putEcheanceInStore (state, echeance) {
      state.editedEcheance = echeance
    }
  }
}
